import gql from 'graphql-tag'

export const fetchTeamsSelect = delegation_id => ({
	query: gql`
		query ($delegation_id: bigint!) {
			teams: organizations_teams(
				where: { delegation_id: { _eq: $delegation_id } }
			) {
				id
				team_name
			}
		}
	`,
	variables: { delegation_id },
	skip: delegation_id == null
})
